import React, { useEffect, useMemo, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { reqToAddBank, reqToGetAllBank, reqToGetBankStats, updateBankStatus, reqToUpdateBank } from "../../../redux/slice/bankSlice";
import { useLoader } from "../../../context/LoaderContext";
import List from "./List";
import { useDispatch, useSelector } from "react-redux";
import { Container } from "react-bootstrap";
import { useNavigate, useNavigationType } from "react-router-dom";
import { ReqUserIcon, UserIcon } from "../../../assets/icons";
import { useToast } from "../../../context/TostContext";
import ConfirmModal from "../../../components/withModal/ConfirmModal";
import { usePermission } from "../../../hooks/usePermission";
import BankModal from "./BankModal";
import { TabCard } from "../../../components/custom-card/Cards";

const MODULE_SLUG = "banks"

export default function Banks() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { setLoading } = useLoader();
  const headerPortalTarget = document.getElementById("header-portal-target");

  const headerContent = (
    <div className="d-flex align-items-center justify-content-between w-100">
      <h4 className="fw-semibold mb-0 text-primary fs-lg">
        <span className="text-muted fw-normal">Bank Manage / </span>Banks
      </h4>
    </div>
  );
  const navigationType = useNavigationType();
  const { hasPermission } = usePermission();

  const canCreate = hasPermission(MODULE_SLUG, "create");
  const canUpdate = hasPermission(MODULE_SLUG, "update");
  const canDelete = hasPermission(MODULE_SLUG, "delete");
  const toast = useToast();

  // Pagination
  const [
    limit,
    setLimit
  ] = useState(() => {
    if (navigationType === "POP") {
      const savedLimit = sessionStorage.getItem("banks_limit");
      if (savedLimit) return JSON.parse(savedLimit);
    }
    return { value: 10, label: 10 };
  });

  const [currentPage, setCurrentPage] = useState(() => {
    if (navigationType === "POP") {
      const savedPage = sessionStorage.getItem("banks_page");
      if (savedPage) return parseInt(savedPage, 10);
    }
    return 1;
  });
  const [searchTerm, setSearchTerm] = useState(() => {
    if (navigationType === "POP") {
      return sessionStorage.getItem("banks_searchTerm") || "";
    }
    return "";
  });
  const [openAddbankModal, setOpenAddbankModal] = useState(false);
  // Status Modal
  const [showStatusModal, setShowStatusModal] = useState(false);
  const [modalItem, setModalItem] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);
  const [editBankData, setEditBankData] = useState(null);

  const list = useSelector((state) => state?.bank?.banks?.data || []);
  const { isLoading } = useSelector((state) => state?.bank || []);
  const bankStats = useSelector((state) => state?.bank?.bankStats || {});
  const total = useSelector((state) => state?.bank?.banks?.meta?.total);

  const AllTypesOfUserCard = [
    {
      id: 1,
      total: bankStats?.data?.total_banks,
      title: "Total Banks",
      icon: <UserIcon size={24} />,
      iconClassName: "icon-secondary",
      status: "",
    },
    {
      id: 2,
      total: bankStats?.data?.total_branches,
      title: "Total Branch",
      icon: <ReqUserIcon size={20} className="text-warning" />,
      iconClassName: "icon-warning",
      status: "pending",
    },
  ];

  // Save to sessionStorage
  sessionStorage.setItem("banks_limit", JSON.stringify(limit));
  sessionStorage.setItem("banks_page", currentPage.toString());
  // sessionStorage.setItem("allUsers_cardStatus", cardStatus);
  sessionStorage.setItem("banks_searchTerm", searchTerm);



  useEffect(() => {
    dispatch(reqToGetBankStats());
  }, [dispatch])

  const handlePageChange = (newPageNumber) => {
    setCurrentPage(newPageNumber);
  };

  const isInitialLoadRef = useRef(true);
  const searchTimeout = useRef(null);

  // Debounced Search Handler
  // const handleSearch = useCallback(() => {
  //   if (searchTimeout.current) {
  //     clearTimeout(searchTimeout.current);
  //   }

  //   searchTimeout.current = setTimeout(() => {
  //     dispatch(reqToGetAllBank({ search: searchTerm, page: currentPage }))
  //   }, 300); // 300ms delay for better UX
  // }, [searchTerm, currentPage, dispatch]);

  // Trigger API Call when search or page changes
  // useEffect(() => {
  //   handleSearch();
  //   return () => clearTimeout(searchTimeout.current);
  // }, [currentPage, handleSearch]);

  useEffect(() => {
    if (searchTimeout.current) {
      clearTimeout(searchTimeout.current);
    }

    const fetchData = () => {
      if (isInitialLoadRef.current) {
        setLoading(true);
      }

      dispatch(
        reqToGetAllBank({
          search: searchTerm,
          page: currentPage,
          // status: cardStatus,
          limit: limit?.value,
        })
      ).finally(() => {
        if (isInitialLoadRef.current) {
          setLoading(false);
          isInitialLoadRef.current = false;
        }
      });
      dispatch(reqToGetBankStats()); // Fetch stats whenever user list parameters change
    };

    if (isInitialLoadRef.current) {
      fetchData();
    } else {
      searchTimeout.current = setTimeout(fetchData, 300);
    }

    return () => {
      if (searchTimeout.current) {
        clearTimeout(searchTimeout.current);
      }
    };
  }, [searchTerm, currentPage, limit?.value, dispatch, setLoading]);

  // Api Call for Search
  // useEffect(() => {
  //   const delayTimeout = setTimeout(() => {
  //     dispatch(reqToGetAllBank({ search: searchTerm, page: currentPage }))
  //   }, 2000); // 3 second delay

  //   return () => clearTimeout(delayTimeout);
  // }, [searchTerm, setLoading, currentPage, dispatch]);

  // API Call to get All Banks in Bank Manage Module
  // const getAllBanks = useCallback(() => {
  //   setLoading(true);
  //   dispatch(
  //     reqToGetAllBank({
  //       page: currentPage,
  //       limit: limit?.value,
  //     })
  //   )
  //     .then(() => {
  //       setLoading(false);
  //     })
  //     .catch((error) => {
  //       setLoading(false);
  //     })
  //     .finally(() => {
  //       setLoading(false);
  //     });
  // }, [dispatch, limit?.value, setLoading, currentPage]);

  // useEffect(() => {
  //   getAllBanks();
  // }, [getAllBanks]);

  // ADD/EDIT Bank Handler
  const handleBankSubmit = async (formData) => {
    setLoading(true);
    try {
      let result;
      if (isEditMode) {
        result = await dispatch(reqToUpdateBank({ id: editBankData.id, data: formData })).unwrap();
      } else {
        result = await dispatch(reqToAddBank({ data: formData })).unwrap();
      }

      if (result?.success === true) {
        toast.success(result?.message || (isEditMode ? "Bank updated successfully!" : "Bank added successfully!"));
        dispatch(reqToGetAllBank({ limit: limit?.value, page: currentPage }));
        dispatch(reqToGetBankStats());
      }
    } catch (err) {
      toast.error(err?.message || (typeof err === 'string' ? err : "Failed to process request!"));
      throw err;
    } finally {
      setLoading(false);
    }
  };

  const handleStatusToggle = (item) => {
    setModalItem(item);
    setShowStatusModal(true);
  };

  const confirmStatusChange = () => {
    if (!modalItem) return;

    setLoading(true);
    const formData = new FormData();
    formData.append("is_active", !modalItem.is_active ? "true" : "false");
    dispatch(
      updateBankStatus({
        id: modalItem.id,
        data: formData,
      })
    )
      .unwrap()
      .then((res) => {
        if (res?.success) {
          toast.success(res?.message || "Status updated successfully!");
          dispatch(reqToGetAllBank({ limit: limit?.value, page: currentPage }));
          setShowStatusModal(false);
        } else {
          toast.error(res?.message || "Failed to update status!");
        }
      })
      .catch((err) => {
        toast.error(err?.message || (typeof err === 'string' ? err : "Failed to update status!"));
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleEdit = (item) => {
    setEditBankData(item);
    setIsEditMode(true);
    setOpenAddbankModal(true);
  };

  // Close Add Bank Modal
  const handleCloseAddBankModal = () => {
    setOpenAddbankModal(false);
    setIsEditMode(false);
    setEditBankData(null);
  };

  const paginationConfig = useMemo(() => ({
    currentPage,
    totalPages: Math.ceil(total / limit?.value) || 1,
    total: total || 0,
    onPageChange: (page) => setCurrentPage(page),
    pageSize: limit?.value,
    setPageSize: (size) => setLimit({ value: size, label: size }),
    setCurrentPage
  }), [currentPage, total, limit]);

  return (
    <>
      {headerPortalTarget && createPortal(headerContent, headerPortalTarget)}

      <Container fluid className="px-0">
        <div className="grid gap-4">
          {AllTypesOfUserCard?.map((item, i) => (
            <TabCard
              key={i}
              count={item?.total}
              title={item?.title}
              className="g-col-4 g-col-xxl-3"
              icon={item?.icon}
              iconClassName={item?.iconClassName}
            />
          ))}
        </div>
        <div className="bg-white rounded-2 overflow-hidden common-shadow mt-4">
          <List
            data={list}
            isLoading={isLoading}
            isInitialLoad={isInitialLoadRef.current}
            navigate={navigate}
            searchTerm={searchTerm}
            limit={limit}
            total={total}
            currentPage={currentPage}
            setCurrentPage={setCurrentPage}
            handlePageChange={handlePageChange}
            setSearchTerm={setSearchTerm}
            setOpenAddbankModal={setOpenAddbankModal}
            handleStatusToggle={handleStatusToggle}
            handleEdit={handleEdit}
            canCreate={canCreate}
            canUpdate={canUpdate}
            canDelete={canDelete}
            pagination={paginationConfig}
          />

          {/* Add Bank Modal */}
          <BankModal
            isOpen={openAddbankModal}
            onClose={handleCloseAddBankModal}
            isEditMode={isEditMode}
            editBankData={editBankData}
            onSubmit={handleBankSubmit}
            title={isEditMode ? "Update Bank" : "Create New Bank"}
          />
        </div>
      </Container>

      {/* Status Confirmation Modal */}
      <ConfirmModal
        isOpen={showStatusModal}
        onClose={() => {
          setShowStatusModal(false);
          setModalItem(null);
        }}
        title={modalItem?.is_active ? "Deactivate User" : "Activate User"}
        message={
          modalItem?.is_active
            ? "Do you want to inactive?"
            : "Do you want to active?"
        }
        size="sm"
        onConfirm={confirmStatusChange}
      />
    </>
  );
}
